import React, { useEffect, useMemo, useState } from 'react';
import classes from './styles.module.scss';
import { useKato } from '../../../contexts/kato.context';
import { IKatoTreeItem, KatoType } from '../../../types/kato.types';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { t } from '../../../helpers/utils';

const baseClass = 'kato-selects';

const KatoSelects = ({ lang }: { lang: 'ru' | 'kz' }) => {
  const { currentLevel, katoTree } = useKato();
  const { kato } = useParams<{ kato: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedRegion, setSelectedRegion] = useState<IKatoTreeItem | null>(null);
  const [selectedDistrict, setSelectedDistrict] = useState<IKatoTreeItem | null>(null);
  const [selectedVillage, setSelectedVillage] = useState<IKatoTreeItem | null>(null);

  // Заполнение на основе kato
  useEffect(() => {
    if (!katoTree.length || !kato) return;

    for (const region of katoTree) {
      if (+region.kato === +kato) {
        setSelectedRegion(region);
        return;
      }

      for (const district of region.children || []) {
        if (+district.kato === +kato) {
          setSelectedRegion(region);
          setSelectedDistrict(district);
          return;
        }

        for (const village of district.children || []) {
          if (+village.kato === +kato) {
            setSelectedRegion(region);
            setSelectedDistrict(district);
            setSelectedVillage(village);
            return;
          }
        }
      }
    }
  }, [katoTree, kato]);

  const regions = useMemo(() => katoTree, [katoTree]);
  const districts = useMemo(() => selectedRegion?.children || [], [selectedRegion]);
  const villages = useMemo(() => selectedDistrict?.children || [], [selectedDistrict]);

  const onRegionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const regionKato = +e.target.value;
    const region = katoTree.find(r => r.kato === regionKato) || null;
    setSelectedRegion(region);
    setSelectedDistrict(null);
    setSelectedVillage(null);

    if (currentLevel === KatoType.REGION) {
      const updatedPath = location.pathname.replace(/^\/admin\/\d+/, `/admin/${region?.kato}`);

      navigate(updatedPath);
    }
  };

  const onDistrictChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const districtKato = +e.target.value;
    const district = districts.find(d => d.kato === districtKato) || null;
    setSelectedDistrict(district);
    setSelectedVillage(null);

    if (currentLevel === KatoType.DISTRICT) {
      const updatedPath = location.pathname.replace(/^\/admin\/\d+/, `/admin/${district?.kato}`);

      navigate(updatedPath);
    }
  };

  const onVillageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const villageKato = +e.target.value;
    const village = villages.find(v => v.kato === villageKato) || null;
    setSelectedVillage(village);

    if (currentLevel === KatoType.VILLAGE) {
      const updatedPath = location.pathname.replace(/^\/admin\/\d+/, `/admin/${village?.kato}`);

      navigate(updatedPath);
    }
  };

  if (currentLevel === KatoType.OBLAST) return null;

  return (
    <div className={classes[baseClass]}>
      {currentLevel >= KatoType.REGION && (
        <div className={classes[`${baseClass}__item`]}>
          <label htmlFor="region-select">{t('region-name', lang)}</label>
          <select id="region-select" onChange={onRegionChange} value={selectedRegion?.kato ?? ''}>
            {regions.map(region => (
              <option key={region.kato} value={region.kato}>
                {region.nameRu}
              </option>
            ))}
          </select>
        </div>
      )}

      {currentLevel >= KatoType.DISTRICT && (
        <div className={classes[`${baseClass}__item`]}>
          <label htmlFor="district-select">{t('district-name', lang)}</label>
          <select id="district-select" onChange={onDistrictChange} value={selectedDistrict?.kato ?? ''}>
            {districts.map(district => (
              <option key={district.kato} value={district.kato}>
                {district.nameRu}
              </option>
            ))}
          </select>
        </div>
      )}

      {currentLevel >= KatoType.VILLAGE && (
        <div className={classes[`${baseClass}__item`]}>
          <label htmlFor="village-select">{t('village-name', lang)}</label>
          <select id="village-select" onChange={onVillageChange} value={selectedVillage?.kato ?? ''}>
            {villages.map(village => (
              <option key={village.kato} value={village.kato}>
                {village.nameRu}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default KatoSelects;
